import React, { useCallback, useEffect, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { v4 as uuidv4 } from 'uuid';
import { BsVolumeUp } from 'react-icons/bs';
import YouTube, { YouTubeProps } from 'react-youtube';

import { IUsuario } from '../../../hooks/chat';

import socket from '../../../services/socket';
import { useClinica } from '../../../hooks/clinica';
import { ISendMessage } from '../../../components/Chat';
import Button from '../../../components/Button';
import Queue from '../../../utils/queue';
import { IFilaChamado } from '../../AgendaAtendimento';
import api from '../../../services/api';
import getResponseErrors from '../../../utils/getResponseErrors';
import { useToast } from '../../../hooks/toast';
import {
  MainContainer,
  MidiaContainer,
  Video,
  MainChamados,
  TituloChamados,
  ContainerChamados,
  Card,
  AtivoMain,
  AtivoCard,
  AtivoTitulo,
  AtivoHeader,
  AtivoContainer,
  AtivoSubtitulo,
  AtivoSubtitulo2,
  BackDrop,
  ContainerImagem,
  ContentChamados,
  AtivoContainerImagem,
} from './styles';

import Input from '../../../components/Input';
import { Container, Content } from '../../SignIn/styles';
import Loading from '../../../components/Loading';
import { IAgendaSala } from '../../AgendaSalas';
import Select from '../../../components/Select';
import { caracterSplitMidiaPainel } from '../../AgendaSalas/TokenPainel';

const audio = new Audio();

const volumePadrao = 0.7;
const volumePadraoYoutube = 70;

interface FormDados {
  token: string;
  clinica: string;
}

interface IMidiaPainel {
  tipo: string;
  url: string;
}

const ListaPacientesPainel: React.FC = () => {
  const { addToast } = useToast();
  const [clinicaLogado, setClinicaLogado] = useState<number>();

  const [loading, setLoading] = useState(false);

  const [queue, setQueue] = useState(new Queue<IFilaChamado>());
  const [top, setTop] = useState<IFilaChamado | undefined>(undefined);

  const [verifica, setVerifica] = useState(0);

  const [fila, setFila] = useState<IFilaChamado[]>([]);
  const [ultimoChamado, setUltimoChamado] = useState<
    IFilaChamado | undefined
  >();
  const [midiaPainel, setMidiaPainel] = useState<IMidiaPainel>();

  const formRefToken = useRef<FormHandles>(null);

  const { optionsClinica, imagensClinica } = useClinica();

  const exibeComboClinica = optionsClinica && optionsClinica.length > 1;

  const logo =
    imagensClinica.find(img => img.nome === 'logo')?.arquivo_url || '';

  const logoRelatorio =
    imagensClinica.find(img => img.nome === 'logoRelatorio')?.arquivo_url || '';

  const playerRef = useRef<YT.Player | null>(null);

  const onReady: YouTubeProps['onReady'] = event => {
    playerRef.current = event.target;
    if (playerRef.current) playerRef.current.setVolume(volumePadraoYoutube);
  };

  const aumentarVolume = (): void => {
    if (playerRef.current) playerRef.current.setVolume(volumePadraoYoutube);
    const videoBack = document.getElementById('videoBack') as HTMLVideoElement;
    if (videoBack) videoBack.volume = volumePadrao;
  };

  const diminuirVolume = (): void => {
    if (playerRef.current) playerRef.current.setVolume(10);
    const videoBack = document.getElementById('videoBack') as HTMLVideoElement;
    if (videoBack) videoBack.volume = 0.2;
  };

  const opts: YouTubeProps['opts'] = {
    width: '100%',
    height: '100%',
    playerVars: {
      autoplay: 1,
      controls: 1,
      rel: 0,
      loop: 1,
      modestbranding: 1,
      playsinline: 1,
    },
  };

  useEffect(() => {
    const pegahora = (): void => {
      setVerifica(Math.floor(Date.now()));
    };
    setInterval(() => pegahora(), 10000);
    return () => pegahora();
  }, []);

  const handlePush = (dados: IFilaChamado): void => {
    setQueue(queue);
    queue.enqueue(dados);
    setTop(queue.peek());
  };

  const handlePop = (): void => {
    queue.dequeue();
    setTop(queue.peek());
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (clinicaLogado) {
      let sessionId = localStorage.getItem('@AgendaFacil:sessionId');
      if (!sessionId) {
        sessionId = uuidv4();
        localStorage.setItem(
          '@AgendaFacil:sessionId',
          JSON.stringify(sessionId),
        );
      }

      const usuario: IUsuario = {
        clinica: optionsClinica[0]?.label || 'Painel Clinica Definida',
        socketId: socket.id,
        codClinica: clinicaLogado.toString(),
        pagina: 'Painel',
        sessionId,
        usuCodigo: '0',
        usuNome: 'Painel',
        usuTipo: 7,
      };
      socket.emit('registro', usuario);

      socket.on('connect', () => {
        socket.emit('registro', usuario);
      });
      socket.on('connect_error', () => console.log('erro de conexão'));
      socket.on('disconnect', (reason: string) =>
        console.log(`desconectado ${reason}`),
      );

      return () => {
        socket.removeEventListener('connect');
        socket.removeEventListener('connect_error');
        socket.removeEventListener('disconnect');
        socket.removeEventListener('desconectar');
      };
    }
  }, [clinicaLogado, optionsClinica]);

  useEffect(() => {
    const timer = setTimeout(() => {
      aumentarVolume();
    }, 100);

    return () => clearTimeout(timer);
  }, [clinicaLogado]);

  useEffect(() => {
    const next = (): void => {
      handlePop();
      setTimeout(() => {
        setUltimoChamado(undefined);
        aumentarVolume();
      }, 4000); // permanece 4 segundos na tela
    };
    audio.addEventListener('ended', next, false);

    return () => {
      audio.removeEventListener('ended', next);
    };
  }, []);

  useEffect(() => {
    async function VerificaServidor(): Promise<void> {
      try {
        const response = await api.get('/clinicas/datahora');
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Sem Comunicação com o servidor',
          type: 'error',
          description: mensagemErro,
          timeAlive: 10000,
        });
      }
    }

    if (audio.paused && top && clinicaLogado) {
      diminuirVolume();
      audio.src =
        top.Arquivo && top.Arquivo !== ''
          ? top.Arquivo
          : 'https://app-agenda-modelo.s3.amazonaws.com/audio/_audio_padrao.mp3';
      audio.volume = 1;
      audio.play();

      setUltimoChamado(top);

      const nome = document.getElementById('nomePaciente');
      if (nome) {
        nome.style.animationName = 'none';

        requestAnimationFrame(() => {
          setTimeout(() => {
            if (nome) nome.style.animationName = '';
          }, 0);
        });
      }

      setFila(state => {
        const estado = state.find(
          st =>
            st.PacCodigo === top.PacCodigo && st.AgeCodigo === top.AgeCodigo,
        );

        if (estado) return state;

        if (state.length > 9) state.pop();
        return state ? [top].concat(state) : [top];
      });
    } else {
      VerificaServidor();
    }
  }, [addToast, clinicaLogado, top, verifica]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (clinicaLogado) {
      const nomeSocket = `chamar_paciente_painel-${clinicaLogado}`;
      const handleNewMessage = (data: ISendMessage): void => {
        const chamado: IFilaChamado = {
          AgeCodigo: data.idFrom,
          // revisar
          CliCodigo: Number(data.clinica),
          codClinica: Number(data.clinica),
          Arquivo: data.audioUrl,
          PacCodigo: data.idTo,
          Texto: data.mensagem,
          Sala: data.from,
          PacNome: data.to,
        };

        handlePush(chamado);
      };

      socket.on(nomeSocket, handleNewMessage);
      return () => {
        socket.removeEventListener(nomeSocket, handleNewMessage);
      };
    }
  }, [clinicaLogado]);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IFilaChamado[]>(
          `/filaChamados/listaporclinica/${clinicaLogado}`,
        );

        const ultimos10 = response.data.splice(0, 10);

        setFila(ultimos10);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar fila de pessoas',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    if (clinicaLogado) loadDados();
  }, [addToast, clinicaLogado]);

  const handleSubmit = useCallback(
    async (dados: FormDados) => {
      try {
        setLoading(true);
        const response = await api.patch<IAgendaSala>(`/salas/validatoken`, {
          token: dados.token,
          CliCodigo: dados.clinica,
        });

        const { ConNome } = response.data;
        setMidiaPainel({
          tipo: ConNome.split(caracterSplitMidiaPainel)[0],
          url: ConNome.split(caracterSplitMidiaPainel)[1],
        });

        setClinicaLogado(Number(dados.clinica));
      } catch (error: any) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Erro ao validar token',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast],
  );

  return (
    <>
      {loading && <Loading />}

      {!clinicaLogado && (
        <>
          <Container className="justify-content-center">
            <Content>
              <Form ref={formRefToken} onSubmit={handleSubmit}>
                <h1>Token</h1>
                <Input
                  name="token"
                  required
                  placeholder="Insira o token de acesso"
                  textUppercase={false}
                  type="password"
                />
                <br />
                <div className={!exibeComboClinica ? 'd-none' : ''}>
                  <Select name="clinica" options={optionsClinica} />
                </div>

                <Button loading={loading} type="submit" className="mt-2">
                  Entrar
                </Button>
              </Form>
            </Content>
          </Container>
        </>
      )}

      {clinicaLogado && (
        <MainContainer>
          {ultimoChamado && <BackDrop />}

          <MidiaContainer style={{ backgroundImage: `url(${logo})` }}>
            {midiaPainel && midiaPainel.tipo === 'youtube' && (
              <YouTube
                videoId={midiaPainel.url}
                opts={opts}
                onReady={onReady}
                className="absolute inset-0 w-full h-full"
                style={{ width: '100%', height: '100%' }}
              />
            )}

            {midiaPainel && midiaPainel.tipo === 'storage' && (
              <Video id="videoBack" autoPlay loop playsInline>
                <source src={midiaPainel.url} type="video/mp4" />
              </Video>
            )}
            {midiaPainel && midiaPainel.tipo === 'imagem' && (
              <img src={midiaPainel.url} alt="Clínica médica" />
            )}
            {!midiaPainel ||
              (!midiaPainel.tipo && (
                <p>
                  {(optionsClinica &&
                    optionsClinica.length > 0 &&
                    optionsClinica.find(
                      cli => cli.value === clinicaLogado.toString(),
                    )?.label) ||
                    'Unidade Não Definida'}
                </p>
              ))}
          </MidiaContainer>

          <MainChamados>
            <ContentChamados>
              <TituloChamados>Últimas Chamadas</TituloChamados>
              <ContainerChamados>
                {fila.length === 0 ? (
                  <p style={{ textAlign: 'center' }}>Nenhuma chamada recente</p>
                ) : (
                  fila.map(f => (
                    <Card key={`td-${f.PacCodigo}-${f.AgeCodigo}-${f.Sala}`}>
                      <p>{f.PacNome}</p>
                      <p>{f.Sala}</p>
                    </Card>
                  ))
                )}
              </ContainerChamados>
            </ContentChamados>
            <ContainerImagem>
              <img src={logo} alt="Clínica Médica" />
            </ContainerImagem>
          </MainChamados>

          {ultimoChamado && (
            <AtivoMain>
              <AtivoCard>
                <AtivoHeader>
                  <BsVolumeUp
                    style={{
                      height: '4rem',
                      width: '4rem',
                    }}
                  />
                  <AtivoTitulo>Chamada de Paciente</AtivoTitulo>
                </AtivoHeader>
                <AtivoContainer>
                  <div>
                    <AtivoSubtitulo>Paciente</AtivoSubtitulo>
                    <AtivoSubtitulo2 id="nomePaciente" className="text-primary">
                      {ultimoChamado?.PacNome || 'Denis'}
                    </AtivoSubtitulo2>
                  </div>

                  <div style={{ paddingTop: '1.5rem' }}>
                    <AtivoSubtitulo>Dirija-se à</AtivoSubtitulo>
                    <AtivoSubtitulo2>
                      {ultimoChamado?.Sala || 'Consultorio'}
                    </AtivoSubtitulo2>
                  </div>
                  <AtivoContainerImagem>
                    <img src={logoRelatorio} alt="Clínica Médica" />
                  </AtivoContainerImagem>
                </AtivoContainer>
              </AtivoCard>
            </AtivoMain>
          )}
        </MainContainer>
      )}
    </>
  );
};

export default ListaPacientesPainel;
